import { IIntlMessage } from '../../components/_core/IntlMsg/intl-msg.types';

type ReportFailure = (operation: string, error: unknown, specificFailure?: { message: IIntlMessage }) => void;

// Wraps a mutation so its failure is reported to the user (see useOperationErrorHandler). By default the
// failure then resolves, for fire-and-forget callers; `rethrow` keeps it rejecting for a caller that must stop.
export const withFailureReport = <A extends unknown[], R>(
  run: (...args: A) => Promise<R>,
  report: ReportFailure,
  operation: string,
  { message, rethrow = false }: { message?: IIntlMessage; rethrow?: boolean } = {},
) => (...args: A): Promise<R | undefined> =>
  run(...args).catch((error: unknown) => {
    report(operation, error, message ? { message } : undefined);
    if (rethrow) throw error;
    return undefined;
  });
